module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/deleted-34745686.svg";